import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  getValue(val: string) {
    console.warn();
  }

  title = 'owlcarouselinAngular';
  Images = [
    { title: "Contact", text: "Monitor and Schedule filling and emptying of tanks Optimize supply-demand Trace leakages using insights from Real-Time data. Remotely control pump/tank valves. Predict future demand using data analytics.", img: "assets/images/amico.svg", button: "#about" },
  ];

  SlideOptions = {
    items: 1, dots: true, nav: true, loop: true, mouseDrag: true,
    touchDrag: true, pullDrag: true, autoplay: true,
  };
  CarouselOptions = {
    items: 3, dots: true, nav: true, loop: true, mouseDrag: true,
    touchDrag: true, pullDrag: true, autoplay: true,
  };

  title1 = 'owlcarouselinAngular';
  Images1 = [
    { title: "Level Monitoring", text: "Optimize demand-supply, free packages in tank, schedule filling and everything of", img: "assets/img/search2.svg", button: "#about" },
    { title: "Take Data-Driven Decision", text: "Our IIOT Solution will gather data from senders & push it to the cloud. Analytics on", img: "assets/img/take-data.svg", button: "#about" },
    { title: "Flow Monitoring", text: "Two-way communication can help turn on-off flow Values remotely. Also gets insights", img: "assets/img/monitoring.svg", button: "#about" },
    { title: "IIOT Software Platform", text: "Energyly's Intelligent analytics & Insights helps Industries, Restaurants, BFSI and Retail sector", img: "assets/img/iiot.svg", button: "#about" },
    { title: "Predictive Maintenance System", text: "Reduce assests downtime by using AI powered insights of data gathered from IOT Sensor", img: "assets/img/maintence.svg", button: "#about" },
    { title: "Wireless 4g Data Logger System", text: "Simple Plug & Play 4G GSM device which takes data from sensors & send it to cloud.", img: "assets/img/4g.svg", button: "#about" },
  ];

  SlideOptions1 = {
    items: 3, margin: 10, dots: true, nav: true, mouseDrag: true,
    touchDrag: true, pullDrag: true, autoplay: true, responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 2
      },
      940: {
        items: 3
      }
    },
  };
  CarouselOptions1 = {
    items: 3, margin: 10, dots: true, nav: true, mouseDrag: true,
    touchDrag: true, pullDrag: true, autoplay: true, responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 2
      },
      940: {
        items: 3
      }
    },
  };



  title2 = 'owlcarouselinAngular';
  Images2 = [
    { title: "FMCG", img: "assets/img/automation.svg" },
    { title: "Sugar Mills", img: "assets/img/Manufacturing Plants.svg" },
    { title: "Oil and Gas", img: "assets/img/oilgas.svg" },
    { title: "Rubber", img: "assets/img/rubber.svg" },
    { title: "Automotive and Aircraft", img: "assets/img/Solar.svg" },
    { title: "Paint", img: "assets/img/paint.svg" },
    { title: "Pulp and Paper Mills", img: "assets/img/pulp.svg" },
    { title: "Waste Water Treatment Plants", img: "assets/img/wastewatertreatment.svg" },
    { title: "Beverage water", img: "assets/img/beverage.svg" },
    { title: "Dairy Industry", img: "assets/img/dairy.svg" },
    { title: "Textile manufacturing", img: "assets/img/textile.svg" },
    { title: "Glass", img: "assets/img/glass.svg" },
    { title: "Metal Production", img: "assets/img/metal.svg" },
    { title: "Chemical Plants", img: "assets/img/chemical.svg" },
    { title: "Semiconductor Industry", img: "assets/img/semiconducter_industries.svg" },
    { title: "Irrigation Systems", img: "assets/img/irrigation_systems.svg" },
  ];

  SlideOptions2 = {
    items: 5, margin: 10, dots: true, nav: true, mouseDrag: true,
    touchDrag: true, pullDrag: true, autoplay: true, responsive: {
      0: {
        items: 1
      },
      300: {
        items: 3
      },
      400: {
        items: 3
      },
      740: {
        items: 3
      },
      940: {
        items: 5
      }
    },
  };
  CarouselOptions2 = {
    items: 4, margin: 50, dots: true, nav: true, mouseDrag: true,
    touchDrag: true, pullDrag: true, autoplay: true, responsive: {
      0: {
        items: 1
      },
      300: {
        items: 3
      },
      400: {
        items: 3
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      }
    },
  };

}
